const safeDecode = (value) => {
    try {
        return decodeURIComponent(value);
    }
    catch {
        return value;
    }
};
const clean = (href) => safeDecode(href.split("#")[0] ?? "").replace(/^(\.\/|\/)+/, "");
/** Le href du fichier de l'ordre de lecture que `href` désigne ; undefined s'il n'y en a pas ou s'il est ambigu. */
export function resolveHref(files, href) {
    const wanted = clean(href);
    if (!wanted)
        return undefined;
    const exact = files.filter((file) => clean(file.href) === wanted);
    if (exact.length === 1)
        return exact[0].href;
    if (exact.length > 1)
        return undefined;
    // Relatif à un sous-dossier : le chemin du manifest se termine par celui de la citation.
    const suffixed = files.filter((file) => clean(file.href).endsWith(`/${wanted}`));
    if (suffixed.length === 1)
        return suffixed[0].href;
    // L'inverse : la citation porte plus de dossiers que le manifest.
    const shorter = files.filter((file) => wanted.endsWith(`/${clean(file.href)}`));
    return shorter.length === 1 ? shorter[0].href : undefined;
}
/** Le Locator avec le href du manifest, ou undefined quand le fichier est inconnu. */
export function resolveQuoteLocator(files, locator) {
    const href = resolveHref(files, locator.href);
    return href === undefined ? undefined : { ...locator, href };
}
//# sourceMappingURL=quotes.js.map